import { TypeEnum, type Upload } from "@/react/story/types";

class UploadUtilsWrapper {

    getExternalFile(): Upload | null {
        const uri = window.prompt("Indiquez l'URL de votre media :");
        if (uri) {
            const youtubeId = this.getYoutubeId(uri);

            return {
                "#type": TypeEnum.UPLOAD,
                path: uri,
                uri,
                clientFilename: null === youtubeId ? uri.substring(1 + uri.lastIndexOf("/")) : `Vidéo YouTube - ${youtubeId}`,
                mimeType: null,
                youtubeId,
            };
        }

        return null;
    }

    /**
     * Rend l'identifiant YouTube porté par une adresse, ou `null` si elle n'en porte pas.
     *
     * Une adresse que `new URL()` refuse — au premier chef celle, relative, d'un média
     * déposé sur le serveur (`/files/story/…`) — est une entrée parfaitement légitime : elle
     * ne peut simplement désigner aucun hébergeur, donc la réponse est `null`. Répondre
     * par une exception journalisée polluait la console du visiteur d'un `TypeError` par
     * vidéo déposée affichée (`COV-A23`).
     */
    getYoutubeId(uri: string): string | null {
        let url: URL;
        try {
            url = new URL(uri);
        } catch {
            return null;
        }

        const hostname = url.hostname.toLowerCase();
        if ("youtube.com" === hostname || "www.youtube.com" === hostname) {
            return url.searchParams.get("v");
        }
        if ("youtu.be" === hostname) {
            return url.pathname.slice(1) || null;
        }

        return null;
    }

}

const UploadUtils = new UploadUtilsWrapper();

export default UploadUtils;
